module.exports = __webpack_public_path__ + "img/10_uk.b721f4db.svg";